export { default as DailyCarousel } from './DailyCarousel'
